<template>
  <div class="total-order-card">
    <div class="card-title1">
      <span class="total-card-title1">{{ $t("message.subTotal") }}</span>
    </div>
    <span class="total-card-value1"
      >${{ (subTotal).toLocaleString()+'.00' }}</span
    >
    <div class="card-title2">
      <span class="total-card-title2">{{ $t('message.serviceFee') }}</span>
    </div>
    <span class="total-card-value2">${{ Number(hst).toFixed(2) }}</span>
    <div class="card-title3">
      <span class="total-card-title3a">{{ $t("message.total") }}</span>
      <span class="total-card-title3b"
        >{{ Math.floor(Number(points)) }} points</span
      >
    </div>
    <span class="total-card-value3">${{ Number(total).toFixed(2) }}</span>
  </div>
</template>

<script>
export default {
  props: ["subTotal", "hst", "points", "total"],
  name: "store",
};
</script>

<style lang="scss" scoped>
.card-title1 {
  position: relative;
  top: 0;
  left: 0;
  width: 100px;
}

.total-card-title1 {
  position: absolute;
  right: 0;
  top: 6px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #687888;
}

.card-title2 {
  position: relative;
  top: 40px;
  left: 0;
  width: 100px;
}
.total-card-title2 {
  position: absolute;
  right: 0;
  top: 6px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #687888;
}

.card-title3 {
  position: relative;
  top: 95px;
  left: 0;
  width: 100px;
}

.total-card-title3a {
  position: absolute;
  right: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #687888;
}

.total-card-title3b {
  position: absolute;
  right: 0;
  top: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #687888;
}

.total-card-value1 {
  position: absolute;
  right: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  text-align: right;
  color: #45505b;
}

.total-card-value2 {
  position: absolute;
  right: 0;
  top: 40px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  text-align: right;
  color: #45505b;
}

.total-card-value3 {
  position: absolute;
  right: 0;
  bottom: 0;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  text-align: right;
  letter-spacing: -0.1px;
  color: var(--success);
}

.total-order-card {
  position: absolute;
  width: 270px;
  height: 130px;
  right: 10%;
  margin-top: 40px;
}

.order-name {
  display: inline-block;
  margin: 10px 0 5px 0px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  letter-spacing: 0.1px;
  color: #687888;
}
.order-cost {
  float: right;
  margin: 10px 0 5px 0px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #687888;
}

.order-points {
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #687888;
}
.order-price {
  float: right;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: var(--success);
}
.store-address {
  display: block;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #333;
}
</style>